import { render } from "./SuspenseWithError.vue?vue&type=template&id=8e07c7ac&ts=true"
import script from "./SuspenseWithError.vue?vue&type=script&lang=ts"
export * from "./SuspenseWithError.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/正式_ls/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__